import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractPeriodReportEvent from "./AbstractPeriodReportEvent.js";

/**
 * A `PublishEvent` is logged when the accountant considers a report finished. Usually,
 * the accountant will then send a notification to tell the customer the report is
 * ready to be read.
 * Such an event can only come after a CreateEvent in a period report event log.
 */
export default class PublishEvent extends AbstractPeriodReportEvent {
	isStatusEvent() {
		return true;
	}

	isPublish() {
		return true;
	}

	getLabel() {
		return _("Published");
	}

	static getType() {
		return "Publish";
	}
}
